// extracted by mini-css-extract-plugin
export default {"container":"admins-deleted_page_container__wyMhi","headerContainer":"admins-deleted_page_headerContainer__7FJRD"};